<script async setup lang="ts">
import { EventFullData } from '@/entities/interfaces/events';
import PartnersList from '../../components/event/PartnersList.vue';
import PresentationsList from '../../components/event/PresentationsList.vue';

import { getFullEvent } from '@/entities/api/events';
import { onMounted, ref, watch } from 'vue';
import { parseMarkdown } from '@/helpers/parseMarkdown';
import { useEventStore } from '@/stores/events.store';

const eventStore = useEventStore();
const event = eventStore.getEvent;

const eventInfo = ref<EventFullData>();

watch(event, async () => {
  if (!event.value?.id) return;
  getFullEvent(event.value.id).then((res) => {
    eventInfo.value = res;
  });
});

onMounted(async () => {
  if (!event.value?.id) return;
  getFullEvent(event.value.id).then((res) => {
    eventInfo.value = res;
  });
});
</script>

<template>
  <section class="description" v-if="event?.description">
    <h1>Что вас ждет</h1>
    <div
      class="description__content"
      v-html="parseMarkdown(event?.description)"
    ></div>
  </section>
  <section
    class="presentations"
    v-if="eventInfo?.presentations && eventInfo?.presentations.length"
  >
    <h1 class="centered">Программа</h1>
    <PresentationsList
      v-if="eventInfo?.presentations && event"
      :event="event"
      :presentations="eventInfo?.presentations"
    />
  </section>
  <section
    class="partners"
    v-if="eventInfo?.presentations && eventInfo?.partners.length"
  >
    <h1 class="centered">Партнеры</h1>
    <PartnersList v-if="eventInfo?.partners" :partners="eventInfo?.partners" />
  </section>
</template>

<style scoped lang="scss">
.description {
  gap: 140px;
  display: flex;
  margin: 100px 0;

  @media screen and (max-width: 1200px) {
    gap: 60px;
    margin: 60px 0;
  }

  @media screen and (max-width: 1024px) {
    flex-direction: column;
  }

  h1 {
    flex: 1 300px;
    @media screen and (max-width: 1200px) {
      flex: 1 200px;
    }

    @media screen and (max-width: 1024px) {
      flex: 1;
    }
  }

  &__content {
    flex: 1 500px;
    display: block;
    line-height: 32px;
    font-size: var(--font-size-md);
    color: var(--color-mono-700);
    font-weight: var(--font-weight-regular);

    ul {
      margin-left: 20px;
    }

    @media screen and (max-width: 1024px) {
      flex: 1;
    }
  }
}

.partners {
  padding-bottom: 40px;
}
</style>
